import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-w11plus',
    templateUrl: './page-w11plus.component.html',
    styleUrls: ['./page-w11plus.component.css'],
    standalone: false
})
export class PageW11plusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
